import { t } from '@lingui/macro';

export const getCertificateFilename = ({
    title = '',
    certificatesCount,
    certificateTypeName,
    prefixCertificate = true
}) => {
    const i18n = window.i18n;

    const name = `${title}_${certificatesCount}_${certificateTypeName}`;

    if (prefixCertificate) {
        return i18n._(t`Filename - Certificates - ${name}`);
    }

    return i18n._(t`Certificates - ${name}`);
};

export function getTotalCurriculumAndLivePoints(classroomParticipations) {
    let totalCurriculumPoints = 0;
    let totalLiveMathsPoints = 0;

    if (classroomParticipations) {
        classroomParticipations.forEach(({ activityPoints, livePoints }) => {
            totalCurriculumPoints += activityPoints;
            totalLiveMathsPoints += livePoints;
        });
    }

    return {
        totalCurriculumPoints,
        totalLiveMathsPoints
    };
}



// WEBPACK FOOTER //
// ./containers/participation/helpers/utils.js